export const INTEGRATIONS_PATH = '/account/integrations'

export const HUB_PATHS = {
  platform: `${INTEGRATIONS_PATH}/platform`,
  warehouses: `${INTEGRATIONS_PATH}/warehouses`,
  apps: `${INTEGRATIONS_PATH}/apps`,
  carriers: `${INTEGRATIONS_PATH}/carriers`
}

export type HubSection = keyof typeof HUB_PATHS

export function hubSectionOf(pathname: string): HubSection | undefined {
  return (Object.keys(HUB_PATHS) as HubSection[]).find((section) =>
    pathname.startsWith(HUB_PATHS[section])
  )
}
